// utils/file-download.util.ts
export class FileDownloadUtil {
  /**
   * 處理 Blob 物件並觸發瀏覽器下載
   */
  static download(data: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url); // 釋放記憶體
    link.remove();
  }
}